import { jsx as _jsx } from "react/jsx-runtime";
import { Page } from 'components/molecules/page';
const SettingsPageHeader = (props)=>{
    const { titleComponent } = props;
    return /*#__PURE__*/ _jsx(Page.Header, {
        $white: true,
        sticky: true,
        title: titleComponent
    });
};
export { SettingsPageHeader };
